import { isNotDefined } from '@sgme/fp';
import { FormattedNumber } from 'react-intl';

import { useForwardAccumulatorTileId } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectForwardAccumulatorProperty } from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const TotalNotional = () => {
  const tileId = useForwardAccumulatorTileId();

  const totalNotional = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'totalNotional'));
  if (isNotDefined(totalNotional)) {
    return null;
  }

  return (
    <span className="form-control-plaintext p-0 text-end fs-12" data-e2e="total-notional">
      <FormattedNumber value={totalNotional} />
    </span>
  );
};

export default TotalNotional;
